import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { mergeClasses } from '../../classify';
import defaultClasses from './richContent.css';
import { shape, string } from 'prop-types';
import richContentRenderers from './richContentRenderers';

/**
 * RichContent component.
 *
 * This component serves as the pool to determine which type of content is being rendered
 * and pass the data off to the correct system.
 *
 * @typedef RichContent
 * @kind functional component
 *
 * @param {Object} props React component props
 *
 * @returns {React.Element} A React component that renders Heading with optional styling properties.
 */
var RichContent = props => {
  var classes = mergeClasses(defaultClasses, props.classes);
  var rendererProps = _objectSpread(_objectSpread({}, props), {}, {
    classes
  });
  for (var Renderer of richContentRenderers) {
    var {
      Component,
      canRender
    } = Renderer;
    if (canRender(rendererProps.html)) {
      return /*#__PURE__*/React.createElement(Component, rendererProps);
    }
  }
  // If no renderer returned a value
  if (process.env.NODE_ENV === 'development') {
    console.warn("None of the following rich content renderers returned anything for the provided HTML.", richContentRenderers.map(r => "<".concat(r.name, ">")), props.html);
  }
  return null;
};

/**
 * Props for {@link RichContent}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the RichContent
 * @property {String} classes.root CSS class for the root container element
 * @property {String} html Content
 */
RichContent.propTypes = {
  classes: shape({
    root: string
  }),
  html: string
};
export default RichContent;